
import { useState, useEffect, Fragment} from "react";

import Config from "../Config";
import InputText from "./InputText";
import InputCombo from "./InputCombo";
import set from "es-toolkit/compat/set";


function FilterMemory(props)
{
        const [uq, setUQ] = useState(props.uq);
        const [gr, setGr] = useState(null);

        const [filterOption, setFilterOption] = useState([]);

        const [row, setRow] = useState({
        uq: props.uq,
        nazwa: '',
        domyslny: '0',
        filtry: JSON.stringify(props.filterParam),
        });


        var tmpRow = row;

  
        const valChangeListener = (filedName, val, correct, msg) => {                         
                //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                   
                tmpRow[filedName] = val;
                tmpRow[filedName+"_valid"] = correct;                        
                setRow(  JSON.parse(JSON.stringify(tmpRow)) );                
                //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );                     
            }   
        



        const [selected, setSelected] = useState('_x_');

        function onChangeHandler (e) {

              setSelected( e.target.value )

              for(var k=0 ; k< gr.length; k++ )
              {              
                    if(gr[k].v == e.target.value && gr[k].v != '_x_')
                    {
                            //console.log("x", gr[k]);
                            //ustaw filtry........................
                            //gr[k].filtry

                            if(props.filterApproveMemory == undefined)
                            {
                                alert('Brak uchwytu!');                              
                            }else 
                            {
                                  var objFilter = JSON.parse( gr[k].filtry) ;

                                  //porownaj klucze..
                                  var allKey = 1;
                                  var notFoundKey = "";
                                  
                                  var kNow = Object.keys(props.filterParam );
                                  var kNew = Object.keys(objFilter );

                                  //console.log("Filter", kNow);
                                 // console.log("FilterNowy", kNew);

                                  for(var kx=0; kx<kNow.length; kx++)
                                  {
                                        if(kNow[kx] .includes("_valid") ) continue;

                                        var finded = 0;
                                        for(var ky=0; ky < kNew.length; ky++)
                                        {
                                                if(kNow[kx] == kNew[ky]) 
                                                { 
                                                     finded = 1; break; //
                                                }
                                        }

                                        if(finded == 0) { allKey = 0; notFoundKey = kNow[kx] ;   break; }
                                  }

                                  //jesli w bazie jest zapamietanych tyle samo filtrow co aktualnie dodanych w panelu to mozna przeladowac...
                                  if(allKey == 1) props.filterApproveMemory(  objFilter );
                                  if(allKey == 0)
                                  {
                                        alert("Ten filtr jest już nieaktywny! (Brakuje: " + notFoundKey + " )");
                                        delGr();
                                  }
                            }
                            
                           
                            //---------------------------------------
                    }
              }

        };


        const [showDialog,setShowDialog] = useState(0);

        const openDialog = () => 
        { 
            setShowDialog(1);   

            var kNow = Object.keys(props.filterParam );          
            var nOption = new Array();
            
            console.log(kNow);

            for(var k=0; k< kNow.length; k++)
            {   
                nOption.push({
                    filter_name: kNow[k]+"",
                    option: "0",  //0 - to co jest wpisane..
                    value: props.filterParam[ kNow[k] ] + "",
                });
            }
                    
            setFilterOption(nOption);

        }

        const closeDialog = () => { setShowDialog(0);  setFilterOption([]); }

      const getGr = () => {
         
                    fetch( Config.url + '/rest_v1,user_filter', {
                        method: 'POST', 
                        body: JSON.stringify({
                            uq: uq,
                        }), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                    
                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                }else    
                                {
                                    setGr(res.result);                                                                                     
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                
                    });
                            

                    return false;
      }

      const delGr = () => {
         

        if(selected == '_x_') return;


                    fetch( Config.url + '/rest_v1,user_delete_filter', {
                        method: 'POST', 
                        body: JSON.stringify({
                            id:  parseInt( selected),
                        }), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                    
                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                }else    
                                {
                                    setGr(null);                                                                                   
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                
                    });
                            

                    return false;
      }


      const saveFilter = () => {

            if(row.nazwa.length < 1) return;

            var newRef = {
                        uq: props.uq,
                        nazwa: row.nazwa,
                        domyslny: row.domyslny,
                        filtry: JSON.stringify(props.filterParam),
                };

              fetch( Config.url + '/rest_v1,user_set_filter', {
                        method: 'POST', 
                        body: JSON.stringify( newRef ), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 
                    
                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                }else    
                                {
                                    setGr(null);
                                    closeDialog();                                                                                              
                                    setRow(   {...row, ["nazwa"]:''} );   
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                
                    });

      }



    if(gr == null)
    {
        setGr([]);
        getGr();
    }

    
    //---------------------------------------
    //sprawdz czy jakis filtr sie zmienil...

   if(gr != null && selected != '_x_' )
   {

                        var indexSelected = -1;

                        for(var k=0; k< gr.length;k++)
                        {
                            if(selected == gr[k].v) { indexSelected = k; break; }
                        }

                        if(indexSelected > -1 && gr[indexSelected].filtry != undefined)
                        {                            
                                  var objFilter = JSON.parse( gr[indexSelected].filtry) ;

                                  var kNow = Object.keys(props.filterParam );
                                  var kNew = Object.keys(objFilter );                           

                                  var isDiffrent = 0;
                                  var isDiffrentFiled = '';

                                  for(var xt=0; xt < kNow.length; xt++)
                                  {
                                        if(  kNow[xt] .includes("_valid") ) continue; 
                                        if(  kNow[xt] .includes("sortBy") ) continue; 

                                        if(   props.filterParam[ kNow[xt] ] != objFilter[ kNow[xt] ] ) { isDiffrent = 1; isDiffrentFiled = kNow[xt]  + ", " +props.filterParam[ kNow[xt] ]+ " <>" +  objFilter[ kNow[xt] ]; break;   }
                                  }

                                  if(isDiffrent == 1)
                                  {
                                     console.log("Jest roznica, " , isDiffrentFiled);
                                     setSelected('_x_');
                                  }
                        }    
   }

                 
    //---------------------------------------



    var dialog = null;

    if(showDialog == 1)
    {

 

        dialog =  <div className="dlg_window shadowx " >

                        <div className="dlg_title" >Nowy filtr</div>
                        <div className="dlg_msg" >
                   
                           
                                            <div className="form_control form_inline">
                                                <div className="fieldName">Nazwa*</div>
                                                <InputText   userData={props.userData} value={row.nazwa} err={null}  valChange={valChangeListener} goNext={null} name="nazwa" placeholder={"Nazwa: "} className=' w300 ' req='1' firstUp="1" />
                                            </div>

                                               <div className="form_control_inline">
                                                        <div className="fieldName">Domyślny</div>
                                                        <InputCombo items={ [  {v:'0',title:'Nie'},  {v:'1',title:'Tak - ustaw po załadowaniu strony'},  ] }  value={row.domyslny} err={null}  valChange={valChangeListener} goNext={null} name="domyslny" placeholder={"Domyślny:"} className=' w200 ' req='0' firstUp="0" />
                                                        
                                                </div>

                                                <div className="scroll100 gohide">
                                                    <ul>
                                                         {
                                                            filterOption.map(  (op,inxOp) => {
                                                                return <li>{op.filter_name}, {op.option},  {op.value} </li>
                                                            }  ) 
                                                         }
                                                    </ul>
                                                </div>

                        </div>
                                <div className="dlg_btn">
                                    <div className="btn" onClick={closeDialog}   >zamknij</div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div className="btn" atr-type="ok" onClick={saveFilter}>zapisz</div>
                        </div>
        </div>
    }


        return <div className="filter_memory">

                    <span className="link_color" onClick={openDialog}>zapisz filtry</span>
                
                    {
                        selected != '_x_' && 
                        <Fragment>
                                    &nbsp;&nbsp;&nbsp;  <span className="link_color" onClick={delGr} >usuń</span>
                        </Fragment>
                    }                  
                    <br/>

                  
                        {
                            gr != null && gr.length > 1 &&
                            <Fragment>
                                <select value={selected} onChange={onChangeHandler} className="xmemory"> 
                                    {
                                        gr.map( (item,ix) => {
                                            return <option value={item.v}>{item.title}</option>
                                        } )
                                    }
                                </select>    
                            </Fragment>
                        }       
                                                                 
                                          
                   
                    {dialog}            
        </div>
}


export default FilterMemory;